import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack, useTheme } from "native-base";
import Icon from "../icons/Icon";
const IconListItem = ({ icon, children }) => {
    const { colors } = useTheme();
    return (_jsxs(HStack, Object.assign({ space: 5, alignItems: "flex-start", w: "full" }, { children: [_jsx(Icon, { name: icon, size: 24, fill: colors.green[500] }), _jsx(Box, Object.assign({ flex: 1 }, { children: children }))] })));
};
export default IconListItem;
